import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Leads } from '@modules/leads-management/leads/leads';
import { ApiService } from '@services/api/api.service';
import { CalendarAPIService } from '@services/api/calendarAPI.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ReduxService } from '@state-management/redux.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions, EventInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import rrulePlugin from '@fullcalendar/rrule';
import timeGridPlugin from '@fullcalendar/timegrid';
import { commonImages } from '@images/common-images';
import { AuthService } from '@services/auth.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { RRule } from 'rrule';
import { MessageService } from '@services/util/message.service';
import { ProjectService } from '@services/api/project.service';

@Component({
  selector: 'app-project-appointment-create',
  templateUrl: './project-appointment-create.component.html',
  styleUrls: ['./project-appointment-create.component.scss'],
})
export class ProjectAppointmentCreateComponent {
  @ViewChild('fullcalendar') fullcalendar: FullCalendarComponent;
  @Output() isOFICreate = new EventEmitter<boolean>();
  @Input() modalTitle: string;
  @Input() appId = null;
  @Input() modalContent: string;
  @Input() appointmentRendor: Observable<Boolean>;

  common_images = commonImages;

  visible: boolean = false;
  appointment_create: FormGroup;
  hours = Leads.hours;
  minutes = Leads.minutes;
  duration = ['AM', 'PM'];
  insertEvent = {
    attendees: [],
    location: '',
    description: '',
    availablebusy: 'Busy',
    availability: 'private',
    visibility: 'private',
    startDate: null,
    endDate: null,
    starttime: null,
    endtime: null,
    agent: null,
  };

  project_branding: any = null;
  project_id: any = null;
  activeCalendarUser = null;
  public Editor = ClassicEditor;
  AuthUser: any = null;
  event_popup_detail = null;
  event_popup = false;
  calendarAccessUser: any[] = [];
  optional: CalendarOptions = {
    initialView: 'dayGridMonth',
    firstDay: 1,
    initialDate: '2022-01-31',
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: '',
    },
    events: [],
    editable: true,
    selectable: true,
    selectMirror: true,
    expandRows: true,
    slotDuration: '01:00:00',
    scrollTime: '08:00:00',
    dayHeaderFormat: { day: 'numeric', weekday: 'short', omitCommas: true },
    titleFormat: { year: 'numeric', month: 'long' },
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin],
  };
  calendar_views = [
    {
      value: 'timeGridDay',
      name: 'Day',
    },
    {
      value: 'timeGridWeek',
      name: 'Week',
    },
    {
      value: 'dayGridMonth',
      name: 'Month',
    },
  ];
  cal_view_grid = 'timeGridWeek';

  constructor(
    private fb: FormBuilder,
    public Api: ApiService,
    private toaster: ToastrService,
    private localStorageService: LocalStorageService,
    private _CalendarAPIService: CalendarAPIService,
    public lmService: LeadManagementService,
    private redux: ReduxService,
    private Auth: AuthService,
    private message: MessageService,
    public _projectService: ProjectService
  ) {
    this.appointment_create = this.fb.group({
      app_title: null,
      project: null,
      pick_date: null,
      start_time_hours: null,
      start_time_minute: null,
      start_time_AMPM: null,
      end_time_hours: null,
      end_time_minute: null,
      end_time_AMPM: null,
      app_type: null,
      app_desc: null,
      agent_id: [''],
      appointment_type: [''],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.appId?.currentValue) {
      this.app_details = changes?.appId?.currentValue;
    }
    // if (this.app_details) {
    //   this.show();
    // }
  }

  app_details;
  ngOnInit(): void {
    // Fetch project tags data
    this.getProjectTags();

    // Retrieve project ID from local storage
    this.project_id = Crypto.decrypt(this.localStorageService.GetItem('pid'));

    // Fetch all project details based on retrieved project ID
    this.GetProjectList(this.project_id);
    // Fetch list of agents
    this.getAgents();

    // Fetch time-related data for the given project ID
    this.getTime(this.project_id);

    this.calendarOptions();
    this.calendarAccessUsers();

    this.appointmentRendorSub = this.appointmentRendor?.subscribe(() => {
      this.getAppointment();
      this.getUserCalendarDetail();
    });
  }

  // The parent's stream outlives this dialog; left open, each re-render request would
  // re-run both calendar fetches on every destroyed instance too.
  private appointmentRendorSub?: Subscription;

  ngOnDestroy(): void {
    this.appointmentRendorSub?.unsubscribe();
  }

  //#region Calendar

  ngAfterViewInit(): void {
    this.fullcalendar?.getApi()?.render();
  }

  changeToGridView() {
    if (this.cal_view_grid == 'dayGridMonth') {
      this.optional.dayHeaderFormat = {
        weekday: 'short',
      };
    } else {
      this.optional.dayHeaderFormat = { day: 'numeric', weekday: 'short', omitCommas: true };
    }

    this.fullcalendar?.getApi()?.render();
    this.fullcalendar?.getApi()?.changeView(this.cal_view_grid || 'timeGridWeek');
  }

  calendarOptions() {
    this.optional = {
      firstDay: 1,
      initialView: 'timeGridWeek',
      initialDate: new Date(),
      headerToolbar: {
        left: 'prev,next',
        center: 'title',
        right: '',
      },
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin],
      now: new Date(),
      events: [],
      editable: false,
      selectable: false,
      selectMirror: false,
      nowIndicator: true,
      expandRows: true,
      slotDuration: '01:00:00',
      scrollTime: '08:00:00',
      dayHeaderFormat: { day: 'numeric', weekday: 'short', omitCommas: true },
      titleFormat: { year: 'numeric', month: 'long' },
      dayMaxEvents: 3,
      eventClick: event => {
        console.log('eve_eve:', event);
        this.event_popup = true;
        this.event_popup_detail = event.event.extendedProps;
        console.log('eve_del:', this.event_popup_detail);
        let creator_name = '';
        let findCreator = this.originalAssigns.filter(item => item._id == this.event_popup_detail?.extendedProperties?.private?.user_id);
        if (findCreator && findCreator.length > 0) {
          this.event_popup_detail.creator.full_name = findCreator[0].full_name;
        } else {
          this.event_popup_detail.creator.full_name = creator_name;
        }
      },
      eventDidMount: info => {
        const element = info.el.closest('.fc-daygrid-day-events');
        if (element) {
          if (info.event.extendedProps.isAllDay) {
            element.classList.add('all-day-event');
          } else {
            info.view.type === 'dayGridMonth' ? element.classList.add('no-all-day-event') : element.classList.remove('no-all-day-event');
          }
        }
      },
      eventContent: (arg: any) => {
        const viewType = arg.view.type; // e.g., 'dayGridMonth', 'timeGridWeek', etc.
        if (viewType === 'dayGridMonth') {
          // --- Month View Styling ---
          const eventTime = arg.event.extendedProps.start_time || '';
          const titleText = `${eventTime} ${arg.event.title}`;

          const container = document.createElement('div');
          container.classList.add('custom-month-event');

          const dot = document.createElement('span');
          dot.classList.add('event-dot');
          dot.style.backgroundColor = arg.backgroundColor || this.project_branding || '#229276';

          const title = document.createElement('span');
          title.classList.add('event-title');
          title.innerText = titleText;
          container.appendChild(dot);
          container.appendChild(title);
          return { domNodes: [container] };
        }

        // --- Default rendering for week/day views ---
        const title = document.createElement('div');
        title.innerText = arg.event.title;
        title.classList.add('fc-event-title-truncate');

        const time = document.createElement('div');
        time.innerText = arg.event.extendedProps.time;
        time.classList.add('fc-event-time');

        const container = document.createElement('div');
        container.appendChild(title);
        container.appendChild(time);

        return { domNodes: [container] };
      },
      eventMouseEnter: info => {
        const tooltip = document.createElement('div');
        tooltip.innerHTML = info.event.title;
        tooltip.className = 'fc-tooltip'; // Custom class
        tooltip.style.position = 'absolute';
        tooltip.style.top = `${info.jsEvent.pageY + 10}px`;
        tooltip.style.left = `${info.jsEvent.pageX + 10}px`;
        tooltip.style.background = this.project_branding || '#229276';
        tooltip.style.color = '#fff';
        tooltip.style.padding = '5px 10px';
        tooltip.style.borderRadius = '4px';
        tooltip.style.zIndex = '1000';
        document.body.appendChild(tooltip);
        info.el.setAttribute('data-tooltip-id', tooltip.id);
      },
      eventMouseLeave: () => {
        const tooltip = document.querySelector('.fc-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      },

      moreLinkClick: () => {
        const parentPopup = document.querySelectorAll('.fc-popover');
        if (parentPopup.length > 0) {
          for (let i = 0; i < parentPopup.length; i++) {
            parentPopup[i].remove();
            const calendarApi = this.fullcalendar?.getApi();
            if (calendarApi) {
              calendarApi.refetchEvents();
            }
          }
        }

        setTimeout(() => {
          // Changes for more link popup show
          const popoverBody = document.querySelector('.fc-popover-body');

          if (popoverBody) {
            // Select all event titles inside the popover
            const eventNodes = popoverBody.querySelectorAll('.fc-daygrid-event');
            eventNodes.forEach(node => {
              const timeElement = node.querySelector('.fc-event-time');
              const titleElement = node.querySelector('.fc-event-title');
              // Clean time format
              if (timeElement) {
                let timeText = timeElement.textContent || '';
                if (timeText.match(/^\d+a$/)) {
                  timeText = timeText.replace(/a$/, 'am');
                } else if (timeText.match(/^\d+p$/)) {
                  timeText = timeText.replace(/p$/, 'pm');
                }
                timeElement.textContent = timeText;
              }
              // Remove unnecessary ID from the title
              if (titleElement) {
                let titleText = titleElement.textContent || '';
                titleText = titleText.replace(/\s\|\s\(\{[^\}]+\}\)/, ''); // Remove ID pattern
                titleElement.textContent = titleText;
              }
            });
          }

          // For closing the more link popup button
          const closeButton = document.querySelector('.fc-popover-close');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              const parentPopup = document.querySelector('.fc-popover');
              if (parentPopup) {
                parentPopup.remove(); // Remove parent popup
                const calendarApi = this.fullcalendar?.getApi();
                if (calendarApi) {
                  calendarApi.refetchEvents();
                }
              }
            });
          }
        }, 10); // Ensure DOM is updated
      },

      dayMaxEventRows: true, // for all non-TimeGrid views
      views: {
        timeGrid: {
          dayMaxEventRows: 1, // adjust to 6 only for timeGridWeek/timeGridDay
        },
      },
    };
  }

  calendarAccessUsers() {
    this.Api.get(`/users/calendar-access-received/${this.Api.getUserId()}`).subscribe(res => {
      this.calendarAccessUser = [];

      this.Auth.getUser().subscribe(user => {
        let authUser = user['data'];

        this._projectService.getProjectBranding(this.project_id).subscribe({
          next: response => {
            this.project_branding = response?.data?.primary_color ? response?.data?.primary_color : response?.data?.secondary_color;
            this.AuthUser = [
              {
                _id: authUser._id,
                full_name: authUser.full_name,
                color: authUser.color,
                email: authUser.email,
              },
              {
                _id: this.project_id,
                full_name: this.ProjectList[0]?.Project_Name,
                color: this.project_branding ? this.project_branding : '#229276',
                isProject: true,
              },
            ];

            if (res?.data?.length > 0) {
              res.data?.forEach(element => {
                if (element.users) {
                  this.calendarAccessUser.push(element.users);
                }
              });
              this.calendarAccessUser.push(...this.AuthUser);
              this.calendarAccessUser = Array.from(new Map(this.calendarAccessUser.map(item => [item._id, item])).values());
              this.calendarAccessUser = this.calendarAccessUser.sort((a, b) => (a?.full_name > b?.full_name ? 1 : -1));
            } else {
              this.calendarAccessUser = this.AuthUser;
            }
          },
        });
        this.activeCalendarUser = [this.project_id];
        this.getAppointment();
        console.log('calendarAccessUser >>:', this.calendarAccessUser);
      });
    });
  }

  getUserCalendarDetail(isToast = false) {
    let records = this.calendarAccessUser?.filter(user => this.activeCalendarUser?.includes(user?._id));
    console.log('record >>:', records);
    let user_id = this.activeCalendarUser?.length > 0 ? this.activeCalendarUser : [this.Api.getUserId()];
    this._CalendarAPIService.getCalendarEventsByUserIds(user_id, 'Property').subscribe({
      next: response => {
        const { status, message, data } = response;
        if (status) {
          isToast && this.toaster.success('Google Calendar refreshed');
          this.optional.events = [];
          let tempEventList: EventInput[] = [];

          if (data?.events?.length > 0) {
            data?.events?.forEach(ele => {
              records.forEach(user => {
                if (ele.summary == user?.email) {
                  ele['color'] = user?.color || this.project_branding || '#229276';
                }
              });
              if (ele?.items?.length > 0) {
                ele.items.forEach(itm => {
                  let isAllDay = itm?.start?.date !== undefined; // Check if it's a public holiday (All-day event)
                  let eventObj: EventInput;
                  if (isAllDay) {
                    eventObj = {
                      title: itm?.summary,
                      time: '',
                      start: itm?.start?.date, // Only date, no time
                      end: itm?.end?.date, // Only date, no time
                      extendedProps: { ...itm, allDay: true, calendar_id: itm?.id },
                      backgroundColor: ele?.color || this.project_branding || '#229276', // Highlight holidays with yellow
                    };
                    tempEventList.push(eventObj);
                  } else {
                    let rule = itm?.recurrence?.length > 0 ? RRule.fromString(itm?.recurrence[0]) : {};
                    let dated = new Date(itm?.start?.dateTime);
                    let hours = dated.getHours();
                    let min = dated.getMinutes();
                    let second = dated.getSeconds();
                    let ruled = {
                      ...rule['options'],
                      dtstart: dated,
                      byhour: [hours],
                      byminute: [min],
                      bysecond: [second],
                    };
                    if (rule['options']?.freq !== undefined) {
                      tempEventList.push({
                        title: itm.summary,
                        date: itm?.start?.dateTime,
                        time: `${this.formatTimeRange(itm?.start?.dateTime, itm?.end?.dateTime)}`,
                        start_time: `${this.startTimeRange(itm?.start?.dateTime)}`,
                        start: itm?.start?.dateTime,
                        end: itm?.end?.dateTime,
                        rrule: ruled,
                        extendedProps: { ...itm, user_id: ele?.user_id },
                        allDay: false,
                        backgroundColor: ele?.color || this.project_branding || '#229276',
                      });
                    } else {
                      tempEventList.push({
                        title: itm.summary,
                        date: itm?.start?.dateTime,
                        time: `${this.formatTimeRange(itm?.start?.dateTime, itm?.end?.dateTime)}`,
                        start_time: `${this.startTimeRange(itm?.start?.dateTime)}`,
                        start: itm?.start?.dateTime,
                        end: itm?.end?.dateTime,
                        extendedProps: { ...itm, user_id: ele?.user_id },
                        allDay: false,
                        backgroundColor: ele?.color || this.project_branding || '#229276',
                      });
                    }
                  }
                });
              }
            });
          }
          if (records) {
            let isExist = records?.find(ele => ele?.isProject == true);
            let event_list = isExist ? [...this.project_event, ...tempEventList] : tempEventList;
            this.optional = {
              ...this.optional,
              events: [...this.optional.events, ...(event_list || [])],
            };
          } else {
            this.optional = {
              ...this.optional,
              events: [],
            };
          }

          console.log('this.optional >>:', this.optional);

          this.fullcalendar?.getApi()?.render();
        } else {
          this.toaster.error(message);
        }
      },
    });
  }

  startTimeRange(startTime: string): string {
    const start = moment(startTime);
    const startFormat = start.minutes() > 0 ? 'h:mma' : 'ha';
    return `${start.format(startFormat)}`;
  }

  formatTimeRange(startTime: string, endTime: string): string {
    const start = moment(startTime);
    const end = moment(endTime);

    const startFormat = start.minutes() > 0 ? 'h:mm' : 'h';
    const endFormat = end.minutes() > 0 ? 'h:mma' : 'ha';

    return `${start.format(startFormat)} - ${end.format(endFormat)}`;
  }

  clear(item, nameType) {
    /**
     * Clears the specified item from the relevant array based on the nameType.
     * Updates the form controls or class properties accordingly.
     * @param item The item to be removed.
     * @param nameType The type indicating which array to update.
     */
    let localArray = [];
    switch (nameType) {
      case 'calendar':
        // Filter out the item from the 'activeCalendarUser' array and update it.
        localArray = this.activeCalendarUser.filter(x => x !== item);
        this.activeCalendarUser = localArray;
        break;
      default:
        // No action needed for unsupported nameType.
        break;
    }
  }

  project_event: any[] = [];
  copy_project_event: any[] = [];
  getAppointment() {
    const projectId = this.project_id;
    const officeId = this.Api.getOfficeId();
    this.Api.get(`/calendar/fetch-project-events?project_id=${projectId}&office_id=${officeId}`).subscribe({
      next: response => {
        this.optional.events = [];
        this.copy_project_event = this.project_event = [];
        response.data.forEach(itm => {
          const matching = this.appointment_type.find(y => y?.tag_name === itm?.app_type);
          if (matching) {
            itm['background_color'] = matching?.background_color;
          }
          this.project_event.push({
            title: itm?.event?.summary,
            backgroundColor: itm['background_color'] || this.project_branding || '#229276',
            date: itm?.event?.start?.dateTime,
            time: `${this.formatTimeRange(itm?.event?.start?.dateTime, itm?.event?.end?.dateTime)}`,
            start_time: `${this.startTimeRange(itm?.event?.start?.dateTime)}`,
            start: itm?.event?.start?.dateTime,
            end: itm?.event?.end?.dateTime,
            extendedProps: { ...itm?.event, _id: itm?._id },
          });
        });
        this.copy_project_event = this.project_event;
        this.optional = { ...this.optional, events: [...this.optional.events, ...(this.project_event || [])] };
        console.log('optional >>:', this.optional);
      },
      error: () => {
        this.toaster.error('Something went wrong');
      },
    });
  }

  //#endregion calendar

  app_diff_hours: any;
  app_diff_min: any;
  // Fetches appointment setting details for a given project ID
  getTime(pid) {
    this.Api.get('/project-appt-setting/' + pid).subscribe({
      next: data => {
        // Stores the appointment difference in hours and minutes (defaults to 30 minutes if not provided)
        this.app_diff_hours = data['data']?.hours;
        this.app_diff_min = data['data']?.minuts || 30;
      },
    });
  }

  ProjectList: any[] = [];
  // Fetches all projects and filters the list to match the provided project ID
  GetProjectList(id) {
    this.Api.get(`/projects-name-list?office_id=${this.Api.getOfficeId()}`).subscribe((response: any) => {
      const { status, data } = response;
      if (status) {
        this.ProjectList = data?.filter(el => el?._id === id);
        this.show();
      }
    });
  }

  originalAssigns: any;
  // Fetches the list of agents (staff members) associated with the office
  getAgents() {
    let url = `/users/office-staff-list?uid=${this.Api.getUserId()}&officeid=${this.Api.getOfficeId()}&show=staff`;
    this.redux.getSetProjectInfo(true, 'byOffice', url).subscribe({
      next: response => {
        let data = JSON.parse(JSON.stringify(response.data));
        // Maps response data to include full names of agents
        this.originalAssigns = data.map(i => {
          i.full_name = i.first_name + ' ' + i.last_name;
          return i;
        });
      },
    });
  }
  // Updates the appointment form fields based on the selected contact

  is_connected: boolean = false;
  is_Exist: boolean = false;
  exist_lead: any[] = [];
  dis_connected: any[] = [];
  property_project: any = null;
  object_event: any;
  is_submit: boolean = false;
  appointment_client: any[] = [];
  attendeeList: any[] = [];
  emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  onAddEmail(event: any) {
    const value = event.value.trim();

    if (!this.emailRegex.test(value)) {
      const index = this.attendeeList.indexOf(value);
      if (index > -1) {
        this.attendeeList.splice(index, 1);
      }
    }
  }
  // Adds an appointment with the provided details and validates the time
  addAppointment() {
    this.property_project = this.ProjectList?.find(ele => ele?._id === this.appointment_create.controls['project'].value);
    // Checks if the end time is after the start time before proceeding
    if (this.isEndTimeAfterStartTime(this.insertEvent.starttime, this.insertEvent.endtime)) {
      // Creates start and end date objects based on the selected date and time
      var startDate = new Date(this.appointment_create.controls['pick_date'].value);
      startDate.setHours(this.insertEvent.starttime.getHours());
      startDate.setMinutes(this.insertEvent.starttime.getMinutes());
      startDate.setSeconds(this.insertEvent.starttime.getSeconds());

      var endDate = new Date(this.appointment_create.controls['pick_date'].value);
      endDate.setHours(this.insertEvent?.endtime?.getHours());
      endDate.setMinutes(this.insertEvent?.endtime?.getMinutes());
      endDate.setSeconds(this.insertEvent?.endtime?.getSeconds());

      // Converts start time to ISO string and retrieves timezone information
      var timeString = new Date(startDate)?.toISOString();
      var timeZone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;

      // Calculates the duration between start and end times
      var duration = this.dateDiffToString(startDate, endDate);
      var startDate = new Date(timeString);
      var msDuration = (Number(duration.split(':')[0]) * 60 * 60 + Number(duration.split(':')[1]) * 60 + Number(duration.split(':')[2])) * 1000;
      var endDate = new Date(startDate.getTime() + msDuration);

      // Formats the start and end dates as ISO strings
      var isoStartDate = new Date(startDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];

      var isoEndDate = new Date(endDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];

      let date = this.appointment_create.controls['pick_date'].value;
      if (!date) {
        this.toaster.error('Invalid date time');
        this.is_submit = false;
        return;
      }

      // Constructs the event object with details

      this.object_event = {
        summary: `${this.property_project?.Project_Name}: ${this.appointment_create.controls['app_title'].value}`,
        description: this.appointment_create.controls['app_desc'].value,
        start: {
          dateTime: isoStartDate,
          timeZone: timeZone,
        },
        end: {
          dateTime: isoEndDate,
          timeZone: timeZone,
        },
        visibility: this.insertEvent.availability != null ? this.insertEvent.availability : 'private',
        availablebusy: this.insertEvent.availablebusy,
        location: this.property_project?.property_address,
      };

      // Adds additional event properties

      let clientList = this.appointment_client?.length > 0 ? this.appointment_client?.map(ele => ({ email: ele.email })) : [];
      let guestList = this.attendeeList?.length > 0 ? this.attendeeList?.map(ele => ({ email: ele })) : [];
      this.object_event['attendees'] = [...clientList, ...guestList];
      this.object_event['attendeeEmailList'] = this.attendeeList?.length > 0 ? this.attendeeList : [];
      this.object_event['sendNotifications'] = true;
      console.log('object_event >>:', this.object_event);
      // Sets event transparency based on availability status
      if (this.insertEvent.availablebusy.toLowerCase() == 'free') {
        this.object_event['transparency'] = 'transparent';
      }

      this.appointment_client = this.appointment_client?.map(ele => {
        ele = { ...ele, project: this.property_project?._id, project_details: this.property_project?.Project_Name };
        return ele;
      });

      console.log('this.appointment_client >>:', this.appointment_client);
      let payload = {
        emails: this.appointment_client?.map(item => item.email),
        is_project: true,
      };

      // Checks if the project lead already exists before proceeding
      this.Api.post(`/project-leads-exist/${this.property_project?._id}`, payload).subscribe({
        next: response => {
          if (response?.data?.length > 0) {
            this.is_Exist = true;
            this.exist_lead = response?.data;
          } else {
            this.is_Exist = false;
            this.exist_lead = [];
            this.checkConnectedUser(this.object_event);
          }
        },
        error: _ => {
          this.is_submit = false;
        },
      });
    } else {
      // Displays an error if the start time is missing
      this.toaster.error('Please add a start time');
      this.is_submit = false;
    }
  }

  checkConnectedUser(event) {
    let user_id = [];
    user_id = this.appointment_create.controls['agent_id'].value;
    user_id = user_id?.length > 1 ? user_id?.filter(id => id !== this.Api.getUserId()) : user_id;
    this.emailConnected && user_id.push(this.Api.getUserId());
    user_id = [...new Set(user_id)];
    if (user_id?.length > 0) {
      this.Api.post('/google/check-connected', { users: user_id }).subscribe({
        next: res => {
          if (res?.disconnected_users?.length > 0) {
            this.is_submit = false;
            this.is_connected = true;
            this.dis_connected = res?.disconnected_users;
          } else {
            this.is_connected = false;
            this.dis_connected = [];
            this.createEvent(user_id, event);
          }
        },
      });
    } else {
      this.createEvent(user_id, event);
    }
  }

  createEvent(user_id, event) {
    let object_event = {
      app_title: this.appointment_create.controls['app_title'].value,
      app_type: this.appointment_create.controls['app_type'].value,
      office_id: this.Api.getOfficeId(),
      created_by: this.Api.getUserId(),
      edit: this.app_details ? { _id: this.app_details?._id } : null,
      client: this.appointment_client?.length > 0 ? this.appointment_client : [],
      event: event,
      object_reference: this.appointment_create.controls['project'].value,
      object_type: 'Project',
      type: 'Open Home',
      isInspection: false,
      user_id: user_id?.length > 0 ? user_id : this.Api.getUserId() || [],
    };

    this.Api.post('/calendar/insert-project-event', object_event).subscribe(() => {
      this.toaster.success('Event added successfully');
      this.lmService.updateProjectSummary(true);
      this.getAppointment();
      this.close();
      this.getAgents();
      this.appointment_client = [];
      this.attendeeList = [];
      this.is_submit = false;
      this.isOFICreate.emit(true);
      setTimeout(() => {
        this.addclient();
      }, 1500);
    });
  }

  // Checks if the end time is after the start time
  isEndTimeAfterStartTime(startTime, endTime) {
    const start = new Date(startTime);
    const end = new Date(endTime);
    return end > start;
  }

  // Calculates the difference between two dates and returns it as a formatted string
  dateDiffToString(a, b) {
    var diff = Math.abs(a - b);
    var ms = diff % 1000;
    diff = (diff - ms) / 1000;
    var ss = diff % 60;
    diff = (diff - ss) / 60;
    var mm = diff % 60;
    diff = (diff - mm) / 60;
    var hh = diff % 24;
    var days = (diff - hh) / 24;
    return days * 24 + hh + ':' + mm + ':' + ss;
  }

  // Closes the modal and resets the form
  close(isReset = false) {
    this.appId = null;
    this.app_details = null;
    this.insertEvent.description = '';
    this.insertEvent.startDate = '';
    this.insertEvent.starttime = '';
    this.insertEvent.endtime = '';
    this.insertEvent.availablebusy = 'Busy';
    this.insertEvent.availability = 'private';
    this.insertEvent.attendees = [];
    this.message.sendMessage({ isClearItems: true });
    this.activeCalendarUser = null;

    if (isReset) {
      this.appointment_create.reset();
      this.visible = false;
      this.app_details = null;
      this.isOFICreate.emit(false);
    } else {
      this.appointment_create = this.fb.group({
        app_title: null,
        project: this.ProjectList[0]?._id?.toString(),
        agent_id: null,
        pick_date: new Date(),
        start_time_hours: null,
        start_time_minute: null,
        start_time_AMPM: null,
        end_time_hours: null,
        end_time_minute: null,
        end_time_AMPM: null,
        app_type: null,
        app_desc: null,
        first_name: [''],
        last_name: [''],
        mobile_no: [''],
        email: [''],
        contactid: [null],
      });
    }
  }

  // Displays the appointment form and pre-fills data if appointment details exist
  show() {
    this.visible = true;

    if (this.app_details) {
      try {
        this.appointment_create.patchValue({
          app_title: this.app_details?.app_title,
          project: this.app_details.project,
          app_type: this.app_details?.app_type,
          agent_id: this.app_details?.agents.map(el => el?._id),
          pick_date: new Date(this.app_details?.date),
          start_time_hours: String(moment(this.app_details?.event?.start?.dateTime).format('h')),
          start_time_minute: String(moment(this.app_details?.event?.start?.dateTime).format('mm')),
          start_time_AMPM: String(moment(this.app_details?.event?.start?.dateTime).format('A')),
          end_time_hours: String(moment(this.app_details?.event?.end?.dateTime).format('h')),
          end_time_minute: String(moment(this.app_details?.event?.end?.dateTime).format('mm')),
          end_time_AMPM: String(moment(this.app_details?.event?.end?.dateTime).format('A')),
          app_desc: this.app_details?.event?.description,
        });

        this.attendeeList = this.app_details?.event?.attendeeEmailList?.length > 0 ? this.app_details?.event?.attendeeEmailList : [];
        this.appointment_client = this.app_details?.clients.map(({ _id, ...rest }) => rest);

        // Stores start and end time for reference
        this.insertEvent.starttime = new Date(this.app_details?.event?.start?.dateTime);
        this.insertEvent.endtime = new Date(this.app_details?.event?.end?.dateTime);
      } catch (error) {
        console.log('error >>:', error);
      }
    } else {
      // If creating a new appointment, set default values
      this.appointment_create.patchValue({
        project: this.ProjectList[0]?._id?.toString(),
        agent_id: [this.Api.getUserId()],
        pick_date: new Date(),
      });
      this.addclient();
    }

    // Checks if the user's Google Calendar is connected
    this.checkUserStatus();
  }

  contactSelection(e, i) {
    let check_name = e?.name?.split(' ');
    let first_name = check_name?.length > 0 ? check_name[0] : '';
    let last_name = check_name?.length > 1 ? check_name[1] : '';

    this.appointment_client[i].first_name = first_name;
    this.appointment_client[i].last_name = last_name;
    this.appointment_client[i].full_name = e?.name;
    this.appointment_client[i].email = e?.email;
    this.appointment_client[i].mobile_no = e?.mobile_no;
    this.appointment_client[i].contactid = e?._id;

    // moment current system date & time
    this.appointment_client[i].created_at = moment().format('YYYY-MM-DD HH:mm:ss');
  }

  addclient() {
    this.appointment_client.push({
      first_name: '',
      last_name: '',
      full_name: '',
      mobile_no: '',
      email: '',
      send_link: false,
      attendee: false,
      like_dislike: null,
      lead_category: 'project',
      lead_status: 'New',
      lead_type: 'Buyer',
      office_id: this.Api.getOfficeId(),
      contactid: null,
      ofi_id: null,
    });

    console.log('this.appointment_client >>:', this.appointment_client);
  }

  removeClient(i) {
    this.appointment_client.splice(i, 1);
  }

  // Stores the Google authentication URL
  googleAuthUrl: any = null;
  // Tracks whether the user's email is connected to Google Calendar
  emailConnected: boolean = false;
  showConnectBtns: boolean = false;
  // Checks the user's Google Calendar connection status
  checkUserStatus() {
    this._CalendarAPIService.checkGoogleCalendarConnectedStatus().subscribe({
      next: response => {
        if (response.connected == true) {
          this.emailConnected = true;
        } else {
          this.emailConnected = false;
          this.googleAuthUrl = response.data + '&state=' + this.Api.getUserId();
        }
      },
    });
  }

  // Opens a Google authentication popup for calendar connection
  gSuiteLogin() {
    this.is_connected = false;
    this.dis_connected = [];

    // Opens a new window for Google authentication
    var win = window.open(this.googleAuthUrl, 'windowname1', 'width=800, height=600');

    // Listens for a message event indicating successful authentication
    window.addEventListener(
      'message',
      event => {
        if (event.data === 'authenticated') {
          // If authentication is successful, update email connection status
          this.emailConnected = true;
          win.close(); // Close the authentication popup
          this.checkUserStatus(); // Re-check user status after authentication
        }
      },
      false
    );
  }

  // Stores appointment types retrieved from project tags
  appointment_type: any[] = [];
  // Fetches project-related tags, specifically extracting appointment types
  getProjectTags() {
    this.redux.getTags(this.Api.getOfficeId(), true, 'project').subscribe({
      next: response => {
        let allTags = [];
        allTags = [...response?.data];

        // Iterates through the tags to find 'appointment-type' data
        allTags?.forEach(x => {
          [...x.types]?.forEach(y => {
            if (y?.slug == 'appointment-type') {
              this.appointment_type = [...y?.data]; // Stores the appointment types
            }
          });
        });
      },
    });
  }

  // Handles changes in the start hour input field
  startHourChange() {
    // Ensure minute field has a default value
    if (this.appointment_create.controls['start_time_minute'].value == null || this.appointment_create.controls['start_time_minute'].value == '---') {
      this.appointment_create?.patchValue({ start_time_minute: '00' });
    }

    // Ensure hour field has a default value
    if (this.appointment_create.controls['start_time_hours'].value == null || this.appointment_create.controls['start_time_hours'].value == '') {
      this.appointment_create?.patchValue({ start_time_hours: '9' });
    }

    let startTime = moment().format();

    // Convert start time based on AM/PM selection
    if (this.appointment_create.controls['start_time_AMPM'].value == 'PM' && this.appointment_create.controls['start_time_AMPM'].value != '12') {
      startTime = moment()
        .hour(Number(this.appointment_create.controls['start_time_hours'].value) + 12)
        .minute(this.appointment_create.controls['start_time_minute'].value)
        .format();
    } else {
      if (this.appointment_create.controls['start_time_hours'].value == '12' && this.appointment_create.controls['start_time_AMPM'].value == 'AM') {
        startTime = moment()
          .hour(Number(this.appointment_create.controls['start_time_hours'].value) + 12)
          .minute(this.appointment_create.controls['start_time_minute'].value)
          .format();
      } else {
        startTime = moment()
          .hour(this.appointment_create.controls['start_time_hours'].value)
          .minute(this.appointment_create.controls['start_time_minute'].value)
          .format();
      }
    }

    // Calculate end time based on appointment duration
    if (this.app_diff_hours === null && this.app_diff_min === null) {
      this.insertEvent.starttime = new Date(startTime);
      let end_hours = new Date(moment(this.insertEvent.starttime).add(0, 'hours').format());
      this.insertEvent.endtime = new Date(moment(end_hours).add(30, 'm').format());
    } else {
      this.insertEvent.starttime = new Date(startTime);
      let end_hours = new Date(moment(this.insertEvent.starttime).add(this.app_diff_hours, 'hours').format());
      this.insertEvent.endtime = new Date(moment(end_hours).add(this.app_diff_min, 'm').format());
    }

    // Update form with calculated end time
    this.appointment_create?.patchValue({
      end_time_hours: String(moment(this.insertEvent.endtime).format('h')),
      end_time_minute: String(moment(this.insertEvent.endtime).format('mm')),
      end_time_AMPM: String(moment(this.insertEvent.endtime).format('A')),
    });
  }

  // Handles changes in the start minute input field
  startMinuteChange() {
    if (this.appointment_create.controls['start_time_minute'].value != null || this.appointment_create.controls['start_time_minute'].value == '---') {
      let startTime = moment().format();

      // Ensure default hour value if missing
      if (this.appointment_create.controls['start_time_hours'].value == null || this.appointment_create.controls['start_time_hours'].value == '') {
        this.appointment_create?.patchValue({ start_time_hours: '9' });
      }

      // Convert start time based on AM/PM selection
      if (this.appointment_create.controls['start_time_AMPM'].value == 'PM' && this.appointment_create.controls['start_time_AMPM'].value != '12') {
        startTime = moment()
          .hour(Number(this.appointment_create.controls['start_time_hours'].value) + 12)
          .minute(this.appointment_create.controls['start_time_minute'].value)
          .format();
      } else {
        if (this.appointment_create.controls['start_time_hours'].value == '12' && this.appointment_create.controls['start_time_AMPM'].value == 'AM') {
          startTime = moment()
            .hour(Number(this.appointment_create.controls['start_time_hours'].value) + 12)
            .minute(this.appointment_create.controls['start_time_minute'].value)
            .format();
        } else {
          startTime = moment()
            .hour(this.appointment_create.controls['start_time_hours'].value)
            .minute(this.appointment_create.controls['start_time_minute'].value)
            .format();
        }
      }

      // Calculate end time based on appointment duration
      if (this.app_diff_hours === null && this.app_diff_min === null) {
        this.insertEvent.starttime = new Date(startTime);
        let end_hours = new Date(moment(this.insertEvent.starttime).add(0, 'hours').format());
        this.insertEvent.endtime = new Date(moment(end_hours).add(30, 'm').format());
      } else {
        this.insertEvent.starttime = new Date(startTime);
        let end_hours = new Date(moment(this.insertEvent.starttime).add(this.app_diff_hours, 'hours').format());
        this.insertEvent.endtime = new Date(moment(end_hours).add(this.app_diff_min, 'm').format());
      }

      // Update form with calculated end time
      this.appointment_create?.patchValue({
        end_time_hours: String(moment(this.insertEvent.endtime).format('h')),
        end_time_minute: String(moment(this.insertEvent.endtime).format('mm')),
        end_time_AMPM: String(moment(this.insertEvent.endtime).format('A')),
      });
    }
  }

  // Handles changes in the end hour input field
  endHourChange() {
    // Ensure minute field has a default value
    if (this.appointment_create.controls['end_time_minute'].value == null || this.appointment_create.controls['end_time_minute'].value == '---') {
      this.appointment_create?.patchValue({ end_time_minute: '00' });
    }

    // Ensure hour field has a default value
    if (this.appointment_create.controls['end_time_hours'].value == null || this.appointment_create.controls['end_time_hours'].value == '') {
      this.appointment_create?.patchValue({ end_time_hours: '9' });
    }

    let endTime = moment().format();

    // Convert end time based on AM/PM selection
    if (this.appointment_create.controls['end_time_AMPM'].value == 'PM' && this.appointment_create.controls['end_time_AMPM'].value != '12') {
      endTime = moment()
        .hour(Number(this.appointment_create.controls['end_time_hours'].value) + 12)
        .minute(this.appointment_create.controls['end_time_minute'].value)
        .format();
    } else {
      if (this.appointment_create.controls['end_time_hours'].value == '12' && this.appointment_create.controls['end_time_AMPM'].value == 'AM') {
        endTime = moment()
          .hour(Number(this.appointment_create.controls['end_time_hours'].value) + 12)
          .minute(this.appointment_create.controls['end_time_minute'].value)
          .format();
      } else {
        endTime = moment()
          .hour(this.appointment_create.controls['end_time_hours'].value)
          .minute(this.appointment_create.controls['end_time_minute'].value)
          .format();
      }
    }

    this.insertEvent.endtime = new Date(endTime);

    // Update form with calculated end time
    this.appointment_create?.patchValue({
      end_time_hours: String(moment(this.insertEvent.endtime).format('h')),
      end_time_minute: String(moment(this.insertEvent.endtime).format('mm')),
      end_time_AMPM: String(moment(this.insertEvent.endtime).format('A')),
    });
  }

  // Handles changes in the end minute input field
  endMinuteChange() {
    if (this.appointment_create.controls['end_time_minute'].value == null || this.appointment_create.controls['end_time_minute'].value == '---') {
      let endTime = moment().format();

      // Ensure hour field has a default value
      if (this.appointment_create.controls['end_time_hours'].value == null || this.appointment_create.controls['end_time_hours'].value == '') {
        this.appointment_create?.patchValue({ end_time_hours: '9' });
      }

      // Convert end time based on AM/PM selection
      if (this.appointment_create.controls['end_time_AMPM'].value == 'PM' && this.appointment_create.controls['end_time_AMPM'].value != '12') {
        endTime = moment()
          .hour(Number(this.appointment_create.controls['end_time_hours'].value) + 12)
          .minute(this.appointment_create.controls['end_time_minute'].value)
          .format();
      }

      this.insertEvent.endtime = new Date(endTime);
    }
  }
}
